import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-employee-details-placeholder',
  templateUrl: './employee-details-placeholder.component.html',
  styleUrls: ['./employee-details-placeholder.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmployeeDetailsPlaceholderComponent {
  @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();
  public loadingSkeletonSize = new Array(environment.loadingSkeletonSize);

  onCloseButtonClicked() {
    this.closeClicked.emit();
  }
}
